/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Oauth_MissingInputs */

const cs_settings_calendar_oauth_missing = /** @type {(inputs: Settings_Calendar_Oauth_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojení kalendáře přes Google/Microsoft zatím není na serveru připravené. Požádejte správce o nastavení. iCal níže funguje hned.`)
};

const en_settings_calendar_oauth_missing = /** @type {(inputs: Settings_Calendar_Oauth_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google/Microsoft calendar connect is not set up on this server yet. Ask an admin to enable it. iCal below works now.`)
};

/**
* | output |
* | --- |
* | "Google/Microsoft calendar connect is not set up on this server yet. Ask an admin to enable it. iCal below works now." |
*
* @param {Settings_Calendar_Oauth_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_oauth_missing = /** @type {((inputs?: Settings_Calendar_Oauth_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Oauth_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_oauth_missing(inputs)
	return cs_settings_calendar_oauth_missing(inputs)
});